const BASE_URL = 'https://project-express-api-eyln4nn5aa-lz.a.run.app/'
export const API_URL = (slug) => `${BASE_URL}/${slug}`